import { createRoot } from 'react-dom/client'
import './index.css';
import App from './App';
import AccountProvider from 'context/AccountContext';
import UserProvider from 'context/UserContext';
import Auth from "components/Authentication/Auth"
import { BrowserRouter } from "react-router-dom";
import ErrorFaultProvider from 'context/ErrorFaultContext';
import { ErrorFallback } from 'components/ErrorFallback';
import { ScrollToTop } from 'utility/ScrollToTop';
import { CartProvider } from 'react-use-cart';
import { OrdersProvider } from 'context/useOrderData';
import { CompanySaleCheckProvider } from 'context/useCompanySaleCheck';
import { ProductConfigurationProvider } from 'context/useProductConfiguration';
import StorageGate from 'components/StorageGate';
import { ConfigPermissionProvider } from 'context/useConfigPermission';

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);
root.render(
  <StorageGate>
    <ErrorFallback>
      <BrowserRouter>
        <ErrorFaultProvider>
          <Auth>
            <AccountProvider>
              <ConfigPermissionProvider>
              <UserProvider>
                <OrdersProvider>
                  <ProductConfigurationProvider>
                    <CompanySaleCheckProvider>
                      <CartProvider>
                        <App />
                        <ScrollToTop />
                      </CartProvider>
                    </CompanySaleCheckProvider>
                  </ProductConfigurationProvider>
                </OrdersProvider>
              </UserProvider>
              </ConfigPermissionProvider>
            </AccountProvider>
          </Auth>
        </ErrorFaultProvider>
      </BrowserRouter>
    </ErrorFallback>
  </StorageGate>
);
